var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 73,
    viewBox: "0 0 50 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8889 0C6.21827 0 0 6.21827 0 13.8889V58.3333C0 66.004 6.21827 72.2222 13.8889 72.2222H36.1111C43.7817 72.2222 50 66.004 50 58.3333V13.8889C50 6.21827 43.7817 0 36.1111 0H13.8889ZM21.3008 58.3346C21.3008 59.3168 21.691 60.2589 22.3856 60.9535C23.0802 61.6481 24.0222 62.0383 25.0045 62.0383C25.737 62.0383 26.4531 61.8211 27.0622 61.4141C27.6712 61.0071 28.146 60.4287 28.4263 59.7519C28.7066 59.0751 28.78 58.3305 28.637 57.612C28.4941 56.8936 28.1414 56.2336 27.6234 55.7157C27.1054 55.1977 26.4455 54.845 25.7271 54.702C25.0086 54.5591 24.2639 54.6325 23.5872 54.9128C22.9104 55.1931 22.332 55.6678 21.925 56.2769C21.518 56.886 21.3008 57.602 21.3008 58.3346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/App.01b3219c19340fca51a1573fb205213f.svg";
export { ForwardRef as ReactComponent };